var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThemeBeach(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0CC76818-D93C-41CB-9FCB-43B1C4BA6B71") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ThemeIcons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-56.000000, -103.000000)",
    id: "Theme/Beach"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.000000, 103.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#C2DEEA",
    fill: "#FFFFFF",
    cx: 16,
    cy: 16,
    r: 15.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icons/TIF-beach-S",
    transform: "translate(6.000000, 7.000000)",
    fill: "#00A1DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22331429,4.58240019 C9.83405714,11.5565716 13.7142857,17.4006859 13.7142857,17.4006859 L10.0571429,17.4006859 C8.07954286,13.1849145 7.75588571,7.62514305 7.73577143,4.72411447 C4.672,6.67611447 2.70994286,9.51771447 2.70994286,9.51771447 C2.1696,8.0630859 2.59931429,6.52251447 3.02902857,5.60000019 C3.47794286,4.63634305 4.16822857,3.98445733 4.89234286,3.54560019 C2.19885714,3.37645733 0,3.90217162 0,3.90217162 C0.6464,2.49142876 2.03977143,1.70605733 2.9952,1.35771447 C5.05142857,0.608000188 6.89371429,1.51862876 7.86651429,2.18331447 C8.60068571,1.29554305 10.1796571,-0.181028383 12.448,0.0182859026 C13.4610286,0.107885903 15.0107429,0.505600188 16,1.70057162 C16,1.70057162 13.8395429,1.84045733 11.3243429,2.76480019 C12.0987429,3.01074305 12.8850286,3.45600019 13.5341714,4.23040019 C14.1869714,5.00937162 15.0016,6.3862859 14.8553143,7.93142876 C14.8553143,7.93142876 12.5193143,5.7206859 9.22331429,4.58240019 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeBeach);
export default __webpack_public_path__ + "static/media/theme_beach.d702d4e0eb0e49207a27d607a6282d8d.svg";
export { ForwardRef as ReactComponent };